import { Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { setupSentinalOneGroup } from "./sentinalone";

const SentinalOneSetupEn = await fetch(require("./tutorial/setup/en.md")).then(
  (res) => res.text()
);
const SentinalOneSetupDe = await fetch(require("./tutorial/setup/de.md")).then(
  (res) => res.text()
);

// Fresh section per catalog build - see network/section.ts for the rationale.
export const sentinalOneScanners = (): Section => {
  const sentinalOneScanners = new Section("sentinalOne_scanner", [
    new Translation("en", "SentinalOne Scanners"),
    new Translation("en", "SentinalOne-Scanner"),
  ]);
  sentinalOneScanners.help = [
    new Translation(
      "en",
      `Add SentinalOne to get more detailed information about their API!`
    ),
    new Translation(
      "de",
      `Fügen Sie SentinalOne hinzu, um detailliertere Informationen über deren API zu erhalten!`
    ),
  ];
  sentinalOneScanners.description = [
    new Translation("en", SentinalOneSetupEn),
    new Translation("de", SentinalOneSetupDe),
  ];

  setupSentinalOneGroup(sentinalOneScanners, 0);
  return sentinalOneScanners;
};
